/**
 * Phase 3 - German translations module
 */
import enBase from './en.js';
import { translationsDe } from '../../utils/translations/translations.de.js';
import { plansTranslationsDe } from '../../utils/translations/plans/plansTranslations.de.js';

const merged = { ...enBase, ...translationsDe, ...plansTranslationsDe };
export default merged;
